import { getBasePath } from './env'

export const getRouterBasename = (): string => {
  const base = getBasePath()
  return base || '/'
}
